// CSS
import 'slick-carousel/slick/slick.scss';
import '../scss/vendor.scss';
import '../scss/app.scss';
import 'lightbox2/dist/css/lightbox.min.css';

// JS
import jquery from 'jquery';
import {initAjaxForm, initAjaxLink} from './ajax';
import {initBoxLink} from './box-link';
import {initCookieNotice} from './cookies';
import {initMemberApplicant} from './applicant';
// noinspection ES6UnusedImports
import {Collapse} from 'bootstrap';
import 'slick-carousel';
import './breakpoint';
import lightbox from 'lightbox2/dist/js/lightbox';


window.$ = window.jQuery = jquery;

$(document).ready(function (e) {
    // Ajax form
    initAjaxForm();
    $(document).on('change', '.ajax-form input, .ajax-form select', function (e) {
        $(this).closest('form').submit();
    });

    initRiseNumbers();

    // Ajax link
    initAjaxLink();

    // Box link
    initBoxLink();

    // Cookie notice
    initCookieNotice();

    // Member applicant
    initMemberApplicant();

    // Carousel gallery
    initGalleryCarousel();

    // Gallery standard
    initGalleryStandard();

    // Search logic
    initSearch();

    initMenu();

    initExternalLinks();

    // logo
    $(window).scroll(function (event) {
        var scroll = $(window).scrollTop();
        if (scroll > 300) {
            $('.logo').addClass('v2');
        } else {
            $('.logo').removeClass('v2');
        }
    });

    // Breakpoint for subnav
    $(document).on('breakpoint', function (e, x) {
        if (e.originalEvent.isMobile) {
            $('.active-ancestor').addClass('clicked');
            $(document).on('click', '.has-subnav:not(".clicked") > a', function (e) {
                e.preventDefault();
                $('.clicked').removeClass('clicked');
                $(this).parents('.has-subnav').addClass('clicked');
            });

        }
    });

    // flash message
    let elementFlashMessage = $('.flash-message');
    if (elementFlashMessage.length) {
        setTimeout(function () {
            elementFlashMessage.addClass('hidden');
        }, 10000);
    }
});

function animateValue(obj, start, end, duration) {
    let startTimestamp = null;
    const step = (timestamp) => {
        if (!startTimestamp) startTimestamp = timestamp;
        const progress = Math.min((timestamp - startTimestamp) / duration, 1);
        obj.innerHTML = Math.floor(progress * (end - start) + start);
        if (progress < 1) {
            window.requestAnimationFrame(step);
        }
    };
    window.requestAnimationFrame(step);
}

function initRiseNumbers() {

    let element = $('.is-style-text-huge');
    if (element.length < 1) {
        return;

    }

    let first = element.first();
    let firstY = first.offset().top;
    let isDone = false;

    $(window).on('scroll', function () {
        let wY = window.scrollY + window.innerHeight;

        if (wY > firstY && !isDone) {
            isDone = true;
        } else {
            return;
        }

        element.each(function () {
            let n = $(this).text();
            if (!isNaN(parseFloat(n)) && isFinite(n)) {
                animateValue(this, 0, n, 3000);
            }
        });
    });
}


function initGalleryCarousel() {
    $('.is-style-carousel').slick({
        autoplay: true,
        autoplaySpeed: 7000,
        speed: 800,
        arrows: false,
        fade: true
    });
}

function initGalleryStandard() {
    $('.gallery').not('.is-style-carousel').each(function (i) {
        let galleryKey = 'Gallery ' + (i + 1);
        $(this)
            .addClass('lightbox-gallery')
            .find('.gallery-item a')
            .attr('data-lightbox', galleryKey);
    });
}

function initSearch() {
    $('a.search').on('click', function (e) {
        e.preventDefault();
        $('.search-toolbar').slideToggle();
        $('.search-toolbar:visible').find('input[type="text"]').focus();

    });
}

function initMenu() {
    $('.menu-trigger').on('click', function () {
        $(this).toggleClass('active');
        $('#nav-main-mobile').toggleClass('active');
    });

    $('#nav-main-mobile').on('click', '> ul > li.menu-item-has-children:not(".clicked") > a', function (e) {
        e.preventDefault();
        $('#nav-main-mobile li.clicked').removeClass('clicked');
        $(this).parents('li').addClass('clicked');

    });

    $('.current-page-origin').parents('.menu-item').addClass('current-page-origin-parent');
    $('.current-menu-parent').parents('.menu-item').addClass('current-menu-grandparent');
}

function initExternalLinks() {
    var links = document.links;
    for (var i = 0; i < links.length; i++) {
        if (links[i].hostname !== window.location.hostname) {
            links[i].target = '_blank';
        }
    }
}